/**
 * 🔴 SEGURANCA (26/09/2026): o texto da mensagem vem do CLIENTE (WhatsApp, Instagram, e-mail...).
 * A busca de mensagens (TicketMessagesSearchModal, ContactDrawer) e a previa de localizacao
 * punham esse texto CRU num dangerouslySetInnerHTML: uma mensagem com
 * `<img src=x onerror=...>` rodava codigo no painel do atendente (e levava a sessao dele).
 * Regra: escapar SEMPRE antes de montar HTML; so o <mark> do destaque e' nosso.
 */
export const escapeHtml = (value) =>
  String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Texto escapado com o termo buscado dentro de <mark>. Termo vazio = so escapa. */
export const highlightEscaped = (text, term) => {
  const seguro = escapeHtml(text);
  const alvo = escapeHtml(term || "").trim();
  if (!alvo) return seguro;
  try {
    return seguro.replace(new RegExp(`(${escapeRegExp(alvo)})`, "gi"), "<mark>$1</mark>");
  } catch (_) {
    return seguro;
  }
};

export default highlightEscaped;
